import { buildDprSources } from '@velasca/utils/build-dpr-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import {
  Colors,
  Diamond,
  Pois,
  RoundContainer,
  SelectorButton,
  Sole,
  Texture,
  WeftImage,
} from './RoundVariantSelector.styles'
import type { RoundVariantSelectorProps } from './RoundVariantSelector.types'

const rotations = {
  'colori-verticali': '90deg',
  'colori-orizzontali': '0deg',
  'colori-laterali': '-135deg',
  'colori-verticali-2/3-1/3': '90deg',
} as const

export const RoundVariantSelector = ({
  title,
  color,
  selected = false,
  onClick,
}: RoundVariantSelectorProps): JSX.Element | null => {
  if (color?.img) {
    return (
      <SelectorButton selected={selected} onClick={onClick}>
        <RoundContainer>
          <Sole sole={color.sole}>
            <WeftImage
              title={title}
              alt={title}
              imgSrc={setQueryParams(color.img, [
                { name: 'width', value: '30' },
              ])}
              sources={buildDprSources(color.img, [
                { width: 29, dpr: 1 },
                { width: 58, dpr: 2 },
                { width: 87, dpr: 3 },
              ])}
              onError={(e) => {
                // eslint-disable-next-line no-param-reassign
                e.currentTarget.style.display = 'none'
              }}
            />
          </Sole>
        </RoundContainer>
      </SelectorButton>
    )
  }

  if (color?.texture && color.colors) {
    return (
      <SelectorButton selected={selected} onClick={onClick}>
        <RoundContainer>
          <Texture
            title={title}
            texture={color.texture}
            color={color.colors[0]}
            sole={color.sole}
          />
        </RoundContainer>
      </SelectorButton>
    )
  }

  if (color?.colors) {
    if (color.pattern === 'colori-rombi') {
      return (
        <SelectorButton selected={selected} onClick={onClick}>
          <RoundContainer>
            <Diamond colors={color.colors} />
          </RoundContainer>
        </SelectorButton>
      )
    }

    if (color.pattern === 'colori-pois') {
      return (
        <SelectorButton selected={selected} onClick={onClick}>
          <RoundContainer>
            <Pois colors={color.colors} />
          </RoundContainer>
        </SelectorButton>
      )
    }

    const weights =
      color.pattern === 'colori-verticali-2/3-1/3' && color.colors.length === 2
        ? [2, 1]
        : undefined

    return (
      <SelectorButton selected={selected} onClick={onClick}>
        <RoundContainer>
          <Colors
            colors={color.colors}
            sole={color.sole}
            title={title}
            weights={weights}
            rotation={
              color.pattern
                ? rotations[color.pattern as keyof typeof rotations]
                : '0deg'
            }
          />
        </RoundContainer>
      </SelectorButton>
    )
  }

  return null
}
